<template>
  <div class="checkout-page">
    <section class="checkout-intro">
      <span>{{ esEmpleado ? "Apartado por linea" : "Pedido web" }}</span>
      <h1>{{ esEmpleado ? "Apartado de empleado" : "Confirma tu pedido" }}</h1>
      <p>
        {{ esEmpleado
          ? "Guardaremos los productos como apartado rapido del usuario POS activo."
          : "Guardaremos tus productos con tu telefono y te llevaremos a WhatsApp para que Maria lo gestione mas rapido."
        }}
      </p>
    </section>

    <section class="checkout-panel checkout-resumen">
      <div class="panel-title-row">
        <h2>Productos</h2>
        <span>{{ productosCarrito.length }} items</span>
      </div>

      <div class="resumen-lista">
        <article v-for="(prod, i) in productosCarrito" :key="i" class="resumen-prod">
          <img :src="prod.imagen" alt="" />
          <div>
            <strong>{{ prod.nombre }}</strong>
            <span>{{ prod.cantidad }} und.</span>
            <small>
              <template v-if="prod.talla">Talla: {{ prod.talla }}</template>
              <template v-if="prod.tipo"> | Tipo: {{ prod.tipo }}</template>
            </small>
          </div>
          <strong>{{ formatearMoneda(prod.precio * prod.cantidad) }}</strong>
        </article>
      </div>

      <div class="totales">
        <div>
          <span>Total pedido</span>
          <strong>{{ formatearMoneda(totalCarrito) }}</strong>
        </div>
      </div>
    </section>

    <aside v-if="esEmpleado" class="checkout-panel checkout-confirmacion">
      <h2>Apartado por linea</h2>
      <p class="confirmacion-copy">
        No se solicita telefono de cliente. Este apartado queda asociado al
        usuario iniciado en el POS y entra al area de apartado web.
      </p>

      <div class="employee-session">
        <span>Usuario POS</span>
        <strong>{{ nombreEmpleadoSesion }}</strong>
      </div>

      <button
        class="realizar-pedido"
        :disabled="procesandoPedido"
        @click="enviarApartadoEmpleado"
      >
        {{ procesandoPedido ? "Guardando apartado..." : "Guardar apartado por linea" }}
      </button>
    </aside>

    <aside v-else class="checkout-panel checkout-confirmacion">
      <h2>Seguimiento</h2>
      <p class="confirmacion-copy">
        Este numero queda asociado al pedido. Los datos de envio o recogida los
        confirma un asesor por WhatsApp.
      </p>

      <div class="form-group">
        <label>Telefono <span class="required">*</span></label>
        <input
          v-model="telefono"
          type="tel"
          required
          :class="{ 'input-error': telefono && !telefonoValido(telefono) }"
          placeholder="Ej: 312 345 6789"
        />
        <small v-if="telefono && !telefonoValido(telefono)" class="error-text">
          El telefono debe iniciar por 3 y tener 10 digitos. Puedes escribirlo con o sin +57.
        </small>
      </div>

      <p class="terms-note">
        Al confirmar aceptas los
        <a href="/#/politicas" target="_blank" rel="noopener">terminos y condiciones</a>
        de Maxica.
      </p>

      <button
        class="realizar-pedido"
        :disabled="procesandoPedido || !telefono"
        @click="enviarPedido"
      >
        {{ procesandoPedido ? "Guardando pedido..." : "Guardar pedido y abrir WhatsApp" }}
      </button>
    </aside>
  </div>
</template>

<script>
import HttpService from "@/Servicios/HttpService";
import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";
import Swal from "sweetalert2";

export default {
  name: "FinalizarCompra",
  mixins: [NotificacionesMixin],
  data() {
    return {
      telefono: "",
      procesandoPedido: false,
    };
  },
  computed: {
    productosCarrito() {
      return this.$store.getters.productosCarrito || [];
    },
    totalCarrito() {
      return this.$store.getters.totalCarrito || 0;
    },
    esEmpleado() {
      const rol = localStorage.getItem("rol");
      return rol === "cajero" || rol === "inven" || rol === "administrador";
    },
    nombreEmpleadoSesion() {
      return (
        localStorage.getItem("nombreUsuario") ||
        localStorage.getItem("nombre") ||
        localStorage.getItem("usuario") ||
        "S/N"
      );
    },
  },
  mounted() {
    if (this.esEmpleado) {
      this.$nextTick(() => this.enviarApartadoEmpleado());
      return;
    }

    this.telefono =
      localStorage.getItem("telefono") ||
      localStorage.getItem("usuario") ||
      this.telefono;
  },
  methods: {
    normalizarTelefono(valor) {
      let digitos = String(valor || "").replace(/\D+/g, "");
      if (digitos.length > 10 && digitos.startsWith("57")) {
        digitos = digitos.slice(-10);
      }
      return digitos;
    },
    telefonoValido(valor) {
      return /^3\d{9}$/.test(this.normalizarTelefono(valor));
    },
    formatearMoneda(valor) {
      return `$${Number(valor || 0).toLocaleString("es-CO")}`;
    },
    obtenerCodigoPedido(response) {
      if (response && response.codigoPedido) return response.codigoPedido;
      const id = response && (response.idPedido || response.id || response.pedido_id);
      if (!id) return "WEB";
      return `WEB-${String(id).padStart(6, "0")}`;
    },
    construirMensajeMaria(codigoPedido, payload) {
      const productos = (payload.productos || [])
        .map((prod) => {
          const detalle = [
            prod.talla ? `Talla: ${prod.talla}` : null,
            prod.tipo ? `Tipo: ${prod.tipo}` : null,
          ].filter(Boolean).join(" | ");
          return `- ${prod.nombre} x${prod.cantidad}${detalle ? ` (${detalle})` : ""}`;
        })
        .join("\n");

      return [
        `Hola Maria, quiero gestionar mi pedido web ${codigoPedido}.`,
        `Telefono: ${payload.telefono}`,
        `Total: ${this.formatearMoneda(payload.total)}`,
        productos ? `Productos:\n${productos}` : "",
        "Quedo pendiente para que un asesor me ayude con envio o recogida.",
      ].filter(Boolean).join("\n");
    },
    urlMariaPorDefecto(mensaje) {
      return `https://wa.me/573243717299?text=${encodeURIComponent(mensaje)}`;
    },
    async registrarPedidoEnMaria(codigoPedido, payload, response) {
      const mensaje = this.construirMensajeMaria(codigoPedido, payload);
      const fallback = this.urlMariaPorDefecto(mensaje);
      const endpoint = window.location.hostname.includes("localhost")
        ? "http://localhost/maixca/api/chat_whatsapp.php"
        : "/ximena/api/chat_whatsapp.php";

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            accion: "registrarPedidoWebMaria",
            codigoPedido,
            idPedido: response && response.idPedido,
            nombre: payload.nombre,
            telefono: payload.telefono,
            direccion: payload.direccion,
            metodoEntrega: payload.metodoEntrega,
            total: payload.total,
            productos: payload.productos,
            mensaje,
          }),
        });
        const data = await res.json();
        return {
          success: data && data.success,
          url: (data && data.wa_url) || fallback,
        };
      } catch (error) {
        console.warn("No se pudo pre-registrar el pedido en Maria", error);
        return { success: false, url: fallback };
      }
    },
    obtenerIdSesion() {
      return (
        localStorage.getItem("idUsuario") ||
        localStorage.getItem("id") ||
        "S/N"
      );
    },
    crearPayloadApartadoEmpleado() {
      const usuario = localStorage.getItem("usuario") || this.nombreEmpleadoSesion;

      return {
        accion: "registrarPedidoWeb",
        apartadoEmpleado: true,
        origen: "empleado_pos",
        idUsuario: this.obtenerIdSesion(),
        nombreUsuario: this.nombreEmpleadoSesion,
        nombre: `APARTADO RAPIDO LINEA 1 ${usuario}`,
        telefono: usuario,
        direccion: "Recoge en bodega",
        metodoEntrega: "bodega",
        infoAdicional: "APARTADO POR EMPLEADO",
        productos: this.productosCarrito,
        total: this.totalCarrito,
        cedula: null,
      };
    },
    async enviarApartadoEmpleado() {
      if (this.procesandoPedido) return;
      if (!this.productosCarrito.length) {
        this.mostrarNotificacion("error", "El carrito esta vacio.");
        return;
      }

      const payload = this.crearPayloadApartadoEmpleado();
      this.procesandoPedido = true;

      try {
        const response = await HttpService.registrar("vender.php", payload);
        if (!response || response.estado === false) {
          this.mostrarNotificacion(
            "error",
            (response && (response.error || response.mensaje)) || "Error al guardar el apartado."
          );
          return;
        }

        await Swal.fire({
          icon: "success",
          text: "Los productos han pasado al area de apartado web, revisar en -Apartado por linea",
          confirmButtonColor: "#2c73d2",
        });

        localStorage.setItem("primeraCompra", "si");
        localStorage.setItem("requiereMinimoInicial", "false");
        localStorage.setItem("comprasPrevias", "1");
        this.$store.commit("vaciarCarrito");
        this.$router.push({ name: "CatalogoWeb" });
      } catch (error) {
        console.error(error);
        this.mostrarNotificacion("error", "Error al guardar el apartado.");
      } finally {
        this.procesandoPedido = false;
      }
    },
    async enviarPedido() {
      if (this.esEmpleado) {
        await this.enviarApartadoEmpleado();
        return;
      }

      if (this.procesandoPedido) return;
      if (!this.productosCarrito.length) {
        this.mostrarNotificacion("error", "Tu carrito esta vacio.");
        return;
      }
      if (!this.telefonoValido(this.telefono)) {
        this.mostrarNotificacion("error", "El telefono debe iniciar por 3 y tener 10 digitos.");
        return;
      }

      this.telefono = this.normalizarTelefono(this.telefono);

      const nombreLocal =
        localStorage.getItem("nombre") ||
        localStorage.getItem("nombreUsuario") ||
        (this.esEmpleado ? `APARTADO RAPIDO LINEA 1 ${localStorage.getItem("usuario") || ""}` : "Cliente web");
      const idUsuario =
        localStorage.getItem("idUsuario") ||
        localStorage.getItem("id") ||
        "S/N";

      const payload = {
        accion: "registrarPedidoWeb",
        idUsuario,
        nombreUsuario: nombreLocal || "Cliente web",
        nombre: nombreLocal || "Cliente web",
        telefono: this.telefono,
        direccion: "Pendiente por WhatsApp",
        metodoEntrega: "whatsapp",
        infoAdicional: "Pedido web pendiente de gestion por Maria.",
        productos: this.productosCarrito,
        total: this.totalCarrito,
        cedula: null,
      };

      this.procesandoPedido = true;
      try {
        const response = await HttpService.registrar("vender.php", payload);
        if (!response || response.estado === false) {
          this.mostrarNotificacion(
            "error",
            (response && (response.error || response.mensaje)) || "Error al realizar el pedido."
          );
          return;
        }

        const codigoPedido = this.obtenerCodigoPedido(response);
        const maria = await this.registrarPedidoEnMaria(codigoPedido, payload, response);
        localStorage.setItem("telefono", this.telefono);
        localStorage.setItem("primeraCompra", "si");
        localStorage.setItem("requiereMinimoInicial", "false");
        localStorage.setItem("comprasPrevias", "1");
        this.$store.commit("vaciarCarrito");

        await Swal.fire({
          icon: "success",
          title: "Pedido guardado",
          html: `
            <p style="margin:0 0 10px 0;">Tu numero de pedido es:</p>
            <div style="font-size:22px;font-weight:800;letter-spacing:.4px;margin:8px 0 14px 0;">${codigoPedido}</div>
            <p style="margin:0;">Ahora te llevaremos a WhatsApp. Es importante que envies el mensaje preparado para que Maria reciba tu pedido.</p>
          `,
          confirmButtonText: "Abrir WhatsApp",
          confirmButtonColor: "#111111",
          allowOutsideClick: false,
        });

        if (maria && maria.url) {
          window.location.href = maria.url;
        } else {
          this.$router.push({ name: "MiPerfil" });
        }
      } catch (error) {
        console.error(error);
        this.mostrarNotificacion("error", "Error al realizar el pedido.");
      } finally {
        this.procesandoPedido = false;
      }
    },
    mostrarNotificacion(tipo, mensaje) {
      this.$store.commit("mostrarNotificacion", { tipo, mensaje });
    },
  },
};
</script>

<style scoped>
.checkout-page {
  width: min(1120px, calc(100% - 28px));
  margin: 24px auto 54px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 16px;
  align-items: start;
}

.checkout-intro {
  grid-column: 1 / -1;
  background: #111;
  color: #fff;
  border-radius: 8px;
  padding: 22px;
}

.checkout-intro span {
  display: block;
  color: #f1d3a0;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.checkout-intro h1 {
  margin: 0;
  font-size: 1.8rem;
  line-height: 1.15;
}

.checkout-intro p {
  max-width: 620px;
  margin: 8px 0 0;
  color: #e7e0d8;
  font-size: 0.98rem;
}

.checkout-panel {
  background: #fff;
  border: 1px solid #e6e0d8;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
  padding: 18px;
}

.panel-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.checkout-panel h2 {
  margin: 0;
  color: #171717;
  font-size: 1.18rem;
  line-height: 1.2;
}

.panel-title-row span,
.confirmacion-copy,
.terms-note {
  color: #615c55;
  font-size: 0.9rem;
}

.checkout-confirmacion {
  position: sticky;
  top: 102px;
}

.confirmacion-copy {
  margin: 8px 0 16px;
  line-height: 1.45;
}

.employee-session {
  margin: 0 0 16px;
  padding: 12px;
  background: #f6f7f9;
  border: 1px solid #e3e5e8;
  border-radius: 7px;
  display: grid;
  gap: 3px;
}

.employee-session span {
  color: #6a6f78;
  font-size: 0.78rem;
  font-weight: 800;
  text-transform: uppercase;
}

.employee-session strong {
  color: #171717;
  font-size: 1rem;
}

.resumen-lista {
  display: grid;
  gap: 10px;
}

.resumen-prod {
  display: grid;
  grid-template-columns: 68px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: center;
  border-bottom: 1px solid #f0ebe4;
  padding-bottom: 10px;
}

.resumen-prod:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.resumen-prod img {
  width: 68px;
  height: 68px;
  border-radius: 7px;
  background: #f6f6f6;
  object-fit: cover;
}

.resumen-prod div {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.resumen-prod div strong {
  color: #252525;
  font-size: 0.95rem;
  line-height: 1.25;
}

.resumen-prod span,
.resumen-prod small {
  color: #666;
  font-size: 0.86rem;
}

.totales {
  margin-top: 16px;
  border-top: 1px solid #eee8df;
  padding-top: 14px;
}

.totales div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  font-size: 1.05rem;
}

.totales strong {
  font-size: 1.16rem;
}

.form-group {
  margin-bottom: 14px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  color: #292929;
  font-weight: 800;
  font-size: 0.92rem;
}

.form-group input {
  width: 100%;
  border: 1px solid #d8d5cf;
  border-radius: 7px;
  color: #111;
  font-size: 1rem;
  padding: 12px;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}

.form-group input:focus {
  border-color: #111;
  box-shadow: 0 0 0 3px rgba(17, 17, 17, 0.08);
}

.required,
.error-text {
  color: #c92a2a;
}

.input-error {
  border-color: #c92a2a !important;
  background: #fff5f5;
}

.terms-note {
  margin: 8px 0 14px;
  line-height: 1.35;
}

.terms-note a {
  color: #2c73d2;
  font-weight: 800;
}

.realizar-pedido {
  width: 100%;
  min-height: 50px;
  border: 0;
  border-radius: 7px;
  background: #111;
  color: #fff;
  font-size: 1rem;
  font-weight: 850;
  cursor: pointer;
  transition: background 0.18s, transform 0.18s;
}

.realizar-pedido:hover:not(:disabled) {
  background: #2c73d2;
  transform: translateY(-1px);
}

.realizar-pedido:disabled {
  background: #b8bdc6;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .checkout-page {
    grid-template-columns: 1fr;
    width: calc(100% - 22px);
    margin-top: 16px;
    margin-bottom: 128px;
  }

  .checkout-intro {
    padding: 18px;
  }

  .checkout-intro h1 {
    font-size: 1.45rem;
  }

  .checkout-confirmacion {
    position: sticky;
    bottom: 74px;
    top: auto;
    z-index: 10;
    box-shadow: 0 -10px 26px rgba(15, 23, 42, 0.12);
  }
}

@media (max-width: 560px) {
  .checkout-panel {
    padding: 14px;
  }

  .resumen-prod {
    grid-template-columns: 58px minmax(0, 1fr);
  }

  .resumen-prod > strong {
    grid-column: 2;
    justify-self: start;
  }

  .resumen-prod img {
    width: 58px;
    height: 58px;
  }

  .realizar-pedido {
    min-height: 48px;
    font-size: 0.95rem;
  }
}
</style>
